import { render } from "./index.vue?vue&type=template&id=24a893e7&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=24a893e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24a893e7"

export default script